/**
 * Finishing - Forms
 *
 * JS pour la gestion des formulaires
 *
 * @since       03.11.2015
 * @version     1.0.0.0
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery( document ).ready( function() {

//END jQuery document ).ready
});
